package com.snakesworld.game.network

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.FirebaseOptions
import dev.gitlive.firebase.initialize

private var isInitialized = false

actual fun initPlatformFirebase() {
    if (isInitialized) return
    try {
        Firebase.initialize(
            options = FirebaseOptions(
                applicationId = "1:723078884270:web:6e59e56397b489f462763f",
                apiKey = "AIzaSyA6UbAJlvJJy8CQpUZCa5xxCk8TDdrFZu8",
                projectId = "snakes-world-game",
                storageBucket = "snakes-world-game.firebasestorage.app",
                authDomain = "snakes-world-game.firebaseapp.com"
            )
        )
        isInitialized = true
    } catch (_: Throwable) {
        isInitialized = true
    }
}
